import { supabase } from '@/lib/supabase'
import type { Company, Website } from '../types'

export async function getAllCompanies(): Promise<Company[]> {
  const { data, error } = await supabase
    .from('companies')
    .select('*')
    .order('name')

  if (error) throw error
  return data || []
}

export async function createCompany(name: string): Promise<Company> {
  const { data, error } = await supabase
    .from('companies')
    .insert({ name })
    .select()
    .single()

  if (error) throw error
  return data
}

export async function deleteCompany(companyId: string): Promise<void> {
  const { error } = await supabase
    .from('companies')
    .delete()
    .eq('id', companyId)

  if (error) throw error
}

export async function getAllWebsites(companyId: string): Promise<Website[]> {
  const { data, error } = await supabase
    .from('websites')
    .select('*')
    .eq('company_id', companyId)
    .order('priority', { ascending: false })

  if (error) throw error
  return data || []
}

export async function createWebsite(companyId: string, url: string): Promise<void> {
  const { error } = await supabase
    .from('websites')
    .insert({
      company_id: companyId,
      url,
      is_active: true,
    })

  if (error) throw error
}

export async function deleteWebsite(websiteId: string): Promise<void> {
  const { error } = await supabase
    .from('websites')
    .delete()
    .eq('id', websiteId)

  if (error) throw error
}
